const TRANSLATIONS_NAMESPACE = "form-viewer";
export {
  TRANSLATIONS_NAMESPACE
};
//# sourceMappingURL=locale.js.map
